<template>
  <button
    v-if="clickable"
    type="button"
    class="label-badge label-badge-button"
    :class="{ 'personal-label-badge': personal }"
    :style="labelStyle"
    :title="title"
    @click.stop="emit('click-label', label)"
  >
    {{ label.title }}
  </button>
  <span
    v-else
    class="label-badge"
    :class="{ 'personal-label-badge': personal }"
    :style="labelStyle"
  >
    {{ label.title }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { s__ } from '@/locale'

const props = defineProps({
  label: {
    type: Object,
    required: true,
  },
  clickable: {
    type: Boolean,
    default: false,
  },
  personal: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click-label'])

const labelStyle = computed(() => ({
  backgroundColor: props.label?.color || '#999',
  color: '#fff',
}))

const title = computed(() =>
  props.clickable
    ? s__('Labels|Show tasks with this label')
    : props.label?.title || s__('Labels|Label')
)
</script>
